"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import { Debounce } from "vue-debounce-decorator";
let FileSaveConfig = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.save_path = "";
    this.user_data_path = "";
    this.upload_path = "";
    this.auto_clean = false;
    this.auto_save_size = 1e3;
    this.loading_cleaning = false;
    this.open_save_path_loading = false;
    this.open_upload_path_loading = false;
    this.askSaving = false;
    this.change_auto_clean_check = _.debounce((data) => __async(this, null, function* () {
      yield this.changeAutoSettings();
    }), 500);
    this.handleNumChange = _.debounce((data) => __async(this, null, function* () {
      yield this.changeAutoSettings();
      yield API.post(`api://base.local/websockets/main`, {
        model: "fileSystem.checkout"
      });
    }), 800);
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.init_download_path();
      yield this.init_auto_saving();
      yield this.init_user_data_path();
      yield this.get_settings();
    });
  }
  init_upload_path() {
    return __async(this, null, function* () {
      try {
        const upload_path_response = yield API.get(`api://base.local/storages/preference/uploadPath`);
        this.upload_path = upload_path_response.data.value.path;
      } catch (error) {
        const _upload_path = "work:///uploads";
        const _path_response = yield API.post(`api://base.local/file-system/paths/conversion`, {
          kind: "ToAbsolute",
          path: _upload_path
        });
        yield API.put(`api://base.local/storages/preference/uploadPath`, {
          path: _path_response.data.path
        });
        this.upload_path = _path_response.data.path;
      }
    });
  }
  init_auto_saving() {
    return __async(this, null, function* () {
      try {
        const askSavingFlag = yield API.get(`api://base.local/storages/preference/askSaving`);
        this.askSaving = askSavingFlag.data.value.flag;
      } catch (error) {
        const _flag = false;
        yield API.put(`api://base.local/storages/preference/askSaving`, {
          flag: _flag
        });
        this.askSaving = _flag;
      }
    });
  }
  changeAskSaving(flag) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/askSaving`, {
          flag
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  init_download_path() {
    return __async(this, null, function* () {
      try {
        const download_path = yield API.get(
          `api://base.local/storages/preference/downloadPath`
        );
        this.save_path = download_path.data.value.path;
      } catch (e) {
        const _downloadPath = "work:///downloads";
        const _path_response = yield API.post(
          `api://base.local/file-system/paths/conversion`,
          {
            kind: "ToAbsolute",
            path: _downloadPath
          }
        );
        let downloadAbsolutePath = _path_response.data.path;
        yield API.put(`api://base.local/storages/preference/downloadPath`, {
          path: downloadAbsolutePath
        });
        this.save_path = downloadAbsolutePath;
      }
    });
  }
  init_user_data_path() {
    return __async(this, null, function* () {
      try {
        const user_data_path = yield API.get(
          `api://base.local/storages/preference/userDataPath`
        );
        this.user_data_path = user_data_path.data.value.path;
      } catch (e) {
        const _userdataPath = "userdata:///";
        const _path_response = yield API.post(
          `api://base.local/file-system/paths/conversion`,
          {
            kind: "ToAbsolute",
            path: _userdataPath
          }
        );
        yield API.put(`api://base.local/storages/preference/userDataPath`, {
          path: _path_response.data.path
        });
        this.user_data_path = _path_response.data.path;
      }
    });
  }
  get_settings() {
    return __async(this, null, function* () {
      try {
        const auto_response = yield API.get(
          `api://base.local/storages/preference/autoSetting`
        );
        this.auto_clean = auto_response.data.value.auto_clean;
        this.auto_save_size = Number(auto_response.data.value.watch_size);
      } catch (e) {
        let auto_setting = {
          watch_size: 1e3,
          auto_clean: false
        };
        yield API.put(`api://base.local/storages/preference/autoSetting`, __spreadValues({}, auto_setting));
        this.auto_clean = auto_setting.auto_clean;
        this.auto_save_size = auto_setting.watch_size;
      }
    });
  }
  ChooseNewFile() {
    return __async(this, null, function* () {
      try {
        this.open_save_path_loading = true;
        let _download_path = `origin:///${this.save_path}`;
        let response = yield API.post(`api://base.local/file-system/dir-picker`, {
          default_path: _download_path
        });
        let result = yield API.post(
          `api://base.local/file-system/paths/conversion`,
          {
            kind: "ToAbsolute",
            path: response.data.path
          }
        );
        let version_check = yield API.get(`api://base.local/system/devices`);
        if (version_check.data.os.name === "Windows") {
          if (result.data.path === "C:\\" || result.data.path === "D:\\" || result.data.path === "E:\\" || result.data.path === "F:\\" || result.data.path === "G:\\" || result.data.path === "H:\\" || result.data.path === "I:\\" || result.data.path === "J:\\") {
            this.$message.error(
              this.$t("filesaveconfig.file_save_error_message")
            );
            this.open_save_path_loading = false;
            return;
          } else {
            this.save_path = result.data.path;
            yield API.put(`api://base.local/storages/preference/downloadPath`, {
              path: this.save_path
            });
          }
        } else {
          this.save_path = result.data.path;
          yield API.put(`api://base.local/storages/preference/downloadPath`, {
            path: this.save_path
          });
        }
        this.open_save_path_loading = false;
      } catch (error) {
        this.open_save_path_loading = false;
        console.log(error);
      }
    });
  }
  ChooseNewUploadFile() {
    return __async(this, null, function* () {
      try {
        this.open_upload_path_loading = true;
        let _upload_path = `origin:///${this.upload_path}`;
        let response = yield API.post(`api://base.local/file-system/dir-picker`, {
          default_path: _upload_path
        });
        let result = yield API.post(
          `api://base.local/file-system/paths/conversion`,
          {
            kind: "ToAbsolute",
            path: response.data.path
          }
        );
        let version_check = yield API.get(`api://base.local/system/devices`);
        if (version_check.data.os.name === "Windows") {
          if (result.data.path === "C:\\" || result.data.path === "D:\\" || result.data.path === "E:\\" || result.data.path === "F:\\" || result.data.path === "G:\\" || result.data.path === "H:\\" || result.data.path === "I:\\" || result.data.path === "J:\\") {
            this.$message.error(
              this.$t("filesaveconfig.file_save_error_message")
            );
            this.open_upload_path_loading = false;
            return;
          } else {
            this.save_path = result.data.path;
            yield API.put(`api://base.local/storages/preference/uploadPath`, {
              path: this.save_path
            });
          }
        } else {
          this.save_path = result.data.path;
          yield API.put(`api://base.local/storages/preference/uploadPath`, {
            path: this.save_path
          });
        }
        this.open_upload_path_loading = false;
      } catch (error) {
        this.open_upload_path_loading = false;
        console.log(error);
      }
    });
  }
  ChooseUserDataFile() {
    return __async(this, null, function* () {
      try {
        let _download_path = `origin:///${this.user_data_path}`;
        let response = yield API.post(`api://base.local/file-system/dir-picker`, {
          default_path: _download_path
        });
        let result = yield API.post(
          `api://base.local/file-system/paths/conversion`,
          {
            kind: "ToAbsolute",
            path: response.data.path
          }
        );
        let version_check = yield API.get(`api://base.local/system/devices`);
        if (version_check.data.os.name === "Windows") {
          if (result.data.path === "C:\\" || result.data.path === "D:\\" || result.data.path === "E:\\" || result.data.path === "F:\\" || result.data.path === "G:\\" || result.data.path === "H:\\" || result.data.path === "I:\\" || result.data.path === "J:\\") {
            this.$message.error(
              this.$t("filesaveconfig.file_save_error_message")
            );
            return;
          } else {
            this.user_data_path = result.data.path;
            let device_response = yield API.get(
              `api://base.local/system/devices`
            );
            if (device_response.data.os.name === "Windows") {
              this.user_data_path = this.user_data_path + "\\";
            }
            if (device_response.data.os.name === "Mac") {
              this.user_data_path = this.user_data_path + "/";
            }
            yield API.put(`api://base.local/storages/preference/userDataPath`, {
              path: this.user_data_path
            });
          }
        } else {
          this.user_data_path = result.data.path;
          let device_response = yield API.get(`api://base.local/system/devices`);
          if (device_response.data.os.name === "Windows") {
            this.user_data_path = this.user_data_path + "\\";
          }
          if (device_response.data.os.name === "Mac") {
            this.user_data_path = this.user_data_path + "/";
          }
          yield API.put(`api://base.local/storages/preference/userDataPath`, {
            path: this.user_data_path
          });
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  changeAutoSettings() {
    return __async(this, null, function* () {
      let auto_setting = {
        watch_size: this.auto_save_size,
        auto_clean: this.auto_clean
      };
      yield API.put(`api://base.local/storages/preference/autoSetting`, __spreadValues({}, auto_setting));
    });
  }
  CleanRomoteFile() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("filesaveconfig.clean_up_cache_tip_content"),
          this.$t("filesaveconfig.clean_up_cache_tip_title"),
          {
            confirmButtonText: this.$t("filesaveconfig.confirm"),
            cancelButtonText: this.$t("filesaveconfig.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        this.loading_cleaning = true;
        let user_data_response = yield API.get(
          `api://base.local/file-system/paths`,
          {
            params: {
              path: `origin:///${this.user_data_path}`
            }
          }
        );
        const user_data_arr = user_data_response.data.entry;
        for (const file of user_data_arr) {
          if (file.origin_path.indexOf("kuajingvs_main") !== -1) {
            continue;
          }
          try {
            yield API.delete(`api://base.local/file-system/paths`, {
              params: {
                path: `${file.origin_path}`
              }
            });
          } catch (error) {
            continue;
          }
        }
        yield API.post(`api://base.local/websockets/main`, {
          model: "fileSystem.checkout"
        });
        this.$message.success(
          this.$t("filesaveconfig.cache_files_cleaned_up")
        );
        this.loading_cleaning = false;
      } catch (error) {
        console.log(error);
        this.loading_cleaning = false;
      }
    });
  }
};
__decorateClass([
  Debounce(600)
], FileSaveConfig.prototype, "changeAskSaving", 1);
FileSaveConfig = __decorateClass([
  Component
], FileSaveConfig);
export {
  FileSaveConfig as default
};
